module.exports = __webpack_public_path__ + "img/ai_right.24f9cdf0.png";